exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".EditShape__pagePadding___39EYK {\n\tpadding-left: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n\tpadding-right: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.EditShape__oneColumn___1PCQy {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.EditShape__bottomBorder___2P1pV {\n\tborder-bottom: solid 1px #ccc;\n}\n\n.EditShape__radioGroup___3Rpbk {\n\tdisplay: flex;\n\tflex-direction: row !important;\n\tjustify-content: space-between;\n}\n\n.EditShape__radioContainer___1R9Qy {\n\tflex: 1;\n\tflex-direction: column;\n}\n\n.EditShape__radioIcon___5qc5_ {\n\twidth: calc(33vw);\n\theight: calc(33vw); /* TODO: size properly */\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "EditShape__pagePadding___39EYK",
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"inverseMainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["inverseMainTextColour"] + "",
	"oneColumn": "EditShape__oneColumn___1PCQy",
	"bottomBorder": "EditShape__bottomBorder___2P1pV",
	"radioGroup": "EditShape__radioGroup___3Rpbk",
	"radioContainer": "EditShape__radioContainer___1R9Qy",
	"radioIcon": "EditShape__radioIcon___5qc5_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/EditShape.icss
// module id = 1539
// module chunks = 0